export default {
  plp_clear_all: 'Clear all',
  plp_customize: 'Customize',
  plp_engraving: 'Engraving',
  plp_rtr_viewer_desc: 'Rotate and move around',
  plp_filter_and_sort_by: 'Filter and sort by',
  plp_filter_by: 'Filter by',
  plp_go_to: 'Go to',
  alt_images:'Visit',
  plp_and:'and',
  plp_with:'with',
  plp_sunglasses:'Sunglasses',
  plp_accessories:'Accessories',
  plp_load_more_product: 'Load more products',
  plp_load_more_sunglasses: 'Load more sunglasses',
  plp_of: 'of',
  plp_polarized: 'Polarized',
  plp_polarized_mobile: 'P',
  plp_smart_glasses: 'AI Glasses',
  plp_result: 'Result',
  plp_result_for_your_search: ' result for your search',
  plp_results: 'Results',
  plp_results_for_your_search: ' results for your search',
  plp_roxable_label: 'Available for prescription',
  plp_roxable_label_mobile: 'RX-ABLE',
  plp_junior_label: 'KIDS',
  plp_selected: 'Selected',
  plp_separator_dash: '-',
  plp_sort_by: 'Sort by',
  plp_sort_by_menu_options: 'Sort by menu options',
  plp_sort_by_options: 'Sort by options',
  plp_view: 'View',
  plp_view_more: 'View more',
  plp_view_less: 'View less',
  plp_frequently_asked_questions: 'Frequently asked questions',
  plp_viewing: 'Viewing',
  plp_filters_button: 'Filters',
  plp_filters_size_description:
    'The size of the frame counts as functional information, which is defined by one main number:',
  plp_filters_size_hinge_to_hinge:
    '<strong>Hinge-to-hinge distance:</strong> the width of the frame measured from the inside of the eyewear starting from the center of each hinge.',
  plp_colors: 'colors',
  plp_newest: 'Newest',
  plp_suggested: 'Suggested for you',
  plp_low_high: 'Price Low - High',
  plp_high_low: 'Price High - Low',
  no_search_results_title: 'Sorry, it looks like we couldn\'t find any results corresponding to {0}',
  no_result_search_again: 'Search Again',
  'attributes_translated.GENDER': 'Gender',
  'attributes_translated.BRAND': 'Brands',
  plp_price: 'Price',
  plp_installments_info: 'or up to {0}x of {1}',
  'attributes_translated.CUSTOMER_TYPE': 'THE SUN CLUB ONLY',
  'attributes_translated.FRAME_SIZE_DISPLAY': 'Size',
  'attributes_translated.FRAME_FITTING': 'Fit',
  'attributes_translated.HINGE_DISTANCE': 'Hinge',
  'attributes_translated.GEOFIT': 'Bridge choice & nosepads',
  'attributes_translated.FRAME_SHAPE_FACET': 'Frame shape',
  'attributes_translated.FRAME_MATERIAL_FACET': 'Frame material',
  'attributes_translated.FRONT_COLOR_FACET': 'Frame color',
  'attributes_translated.LENS_COLOR_FACET': 'Lens color',
  'attributes_translated.LENS_TREATMENT_FACET': 'Lens type',
  'attributes_translated.MOST_WANTED_STYLES': 'Best seller',
  'attributes_translated.LIMITED_EDITION': 'Limited edition',
  'attributes_translated.POLARIZED': 'Polarized',
  'attributes_translated.SALE': 'Sale',
  'attributes_translated.CHANNEL_DETAILS?EXCLUSIVE SGH': 'Exclusive',
  'attributes_translated.CHANNEL_DETAILS?ONLY AT': 'Only at Sunglasshut',
  'attributes_translated.CHANNEL_DETAILS?ONLINE ONLY': 'Online Only',
  'attributes_translated.FRAME_SHAPE_FACET?Pilot': 'Pilot shape',
  'attributes_translated.PRODUCT_TYPE': 'Product Categories',
  'attributes_translated.CUSTOMIZABLE': 'Customize',
  'attributes_translated.ENGRAVABLE': 'Engrave',
  'attributes_translated.PHOTOCHROMIC': 'Photocromatic',
  'attributes_translated.ROXABLE': 'Prescription',
  plp_gender_unisex: 'UNISEX',
  plp_badge_members_only: 'Members only',
  plp_badge_runway: 'Runway',
  plp_badge_find_it_here_first: 'Find it here first',
  plp_badge_collaboration: 'Collaboration',
  plp_badge_new: 'New',
  plp_badge_sold_out: 'Sold out',
  plp_badge_coming_back: 'Coming back soon',
  'attributes_translated.FRAME_FITTING_Narrow':
    'A frame that covers a smaller portion of the face.',
  'attributes_translated.FRAME_FITTING_Regular':
    'A frame that covers an average portion of the face.',
  'attributes_translated.FRAME_FITTING_Wide': 'A frame that covers a greater portion of the face.',
  'attributes_translated.GEOFIT_Adjustable_Nosepads':
    'Adjustable nosepads can be widened or narrowed to fit your unique nose shape.',
  'attributes_translated.GEOFIT_High_Bridge_Fit':
    'Offers a more secure and comfortable fit for those with a high nose bridge and lower cheekbones. A good choice if the bridge of your nose is above the level of your pupils.',
  'attributes_translated.GEOFIT_Low_Bridge_Fit':
    'Offers a more secure and comfortable fit for those with a low nose bridge and higher cheekbones. A good choice if eyewear tends to slide down your nose, sit too low, or press on your temples or cheeks.',
  'attributes_translated.GEOFIT_Universal_Fit': 'This option accommodates most face shapes.',
  'attributes_translated.LENS_TREATMENT_FACET_Blue_Light_Lenses':
    'Helps protect eyes from blue light emitted by digital devices and the sun, reducing visual discomfort & eye strain',
  'attributes_translated.LENS_TREATMENT_FACET_Classic':
    'Solid or tinted lenses available in a range of colors',
  'attributes_translated.LENS_TREATMENT_FACET_Gradient':
    'Tinted lenses that gradually fade from darkest at the top to clearer at the bottom',
  'attributes_translated.LENS_TREATMENT_FACET_Mirror_&_Flash':
    'A reflective coating that protects against glare and hides your eyes, acting as a one-way mirror',
  'attributes_translated.LENS_TREATMENT_FACET_Photocromatic':
    'Light-responsive lenses that are clear indoors and darken when exposed to sunlight',
  'attributes_translated.LENS_COLOR_FACET_Blue_Light_Lenses':
    'Helps protect eyes from blue light emitted by digital devices and the sun, reducing visual discomfort & eye strain',
  'attributes_translated.LENS_TREATMENT_FACET_Blue-Violet_Light_Filter':
    'Get UV protection and filter blue-violet light with this curated selection of shades.',
  'attributes_translated.LENS_TREATMENT_FACET_Transitions®':
    'Lenses that seamlessly adapt to changes in lighting, transforming from clear to dark when outdoors, and back to clear when you’re inside.',
  plp_price_over: 'Over',
  plp_pending_price: 'Price pending',
  plp_load_more: 'Load more',
  search_input_placeholder: 'What are you looking for?',
  search_popular_links: 'Popular Links',
  search_top_brands: 'Top Brands',
  search_best_seller: 'Best Seller',
  search_clear_input: 'Clear',
  search_recently_searched: 'Recently Searched',
  search_results_title: 'Here’s what we found.',
  search_suggestion_title: 'Suggestions',
  search_tabs_products: 'Products ({0})',
  search_tabs_content: 'Content ({0})',
  search_discover_more: 'Discover More',
  search_no_result_title: 'We couldn’t find that. Check out these instead.',
  search_interested: 'You might be interested in',
  search_chanel_title:
    'Chanel isn’t available online, but locate your nearest store {placeholderLink}.',
  search_chanel_link: '/us/sunglasses-trends/chanel-store-locator',
  search_chanel_label: 'here',
  search_no_brand_title:
    'We don’t carry this brand. Here are some styles that we think you’ll like.',
  add_to_bag: 'Add to bag',
  plp_list_price: 'List price',
  plp_offer_price: 'Discounted price',
}
